export default "__VITE_ASSET__3LAA51PI__"